import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/Buttons";

export const Excel = () => {
    document.title = "Excel";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ümumi anlayışlar", value: "/common" },
        { name: "Excel", value: "/common/excel", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Excel</h2>
                    <p>
                        Məhsulların ümumi siyahısını, anbar qalığını və sənədləri excell formatinda endirmək üçün nəzərdə tutulub. İstifadəçi istənilən vaxt
                        istənilən sənədi excell formatında endirə bilər. Bunun üçün <Button>Yüklə</Button> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/common/excel.gif" alt="Excel" />
                </article>
            </div>
        </div>
    );
};
